<template>
  <span
    class="d-flex align-center text-table-header"
    :class="`bm-table-header-${column.key}`"
    data-cc="table-header"
    :data-id="column.key"
  >
    <slot v-if="isCustomHeader" />

    <span class="d-flex align-center w-100 ga-2" v-else>
      <span class="header" v-sanitize="column.title" />

      <BMTooltip v-if="column.hasOwnProperty('tooltip')" extraSmallIcon>
        <div
          :data-cc="`table-header-tooltip-${column.key}`"
          v-sanitize="column.tooltip"
        />
      </BMTooltip>
    </span>

    <v-spacer />

    <!-- Sorting icons since we use [header.name] slots -->
    <v-icon
      v-if="sortInfo"
      size="small"
      class="sort-icon"
      :class="{ 'sort-icon_inverted': !sortInfo.isAscending }"
      data-cc="table-header-sort-icon"
      :data-id="sortInfo.isAscending ? 'ascending' : 'descending'"
    >
      $arrowup
    </v-icon>

    <v-icon
      v-if="column.sortable && !sortInfo"
      class="hidden-sorting-icon"
      size="small"
      data-cc="table-header-sort-icon"
      data-id="default"
    >
      $arrowup
    </v-icon>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import constants from '@/config/constants';
import BMTooltip from '@/components/common/utilities/BMTooltip.vue';

// Props
const props = withDefaults(
  defineProps<{
    column: any;
    sortValues?:
      | { key: string; order?: boolean | 'asc' | 'desc' }
      | undefined
      | null;
    isCustomHeader?: boolean;
  }>(),
  {
    sortValues: null,
    isCustomHeader: false
  }
);

const sortInfo = computed(() => {
  if (!props.sortValues) return null;
  const { key, order } = props.sortValues;
  if (props.column.key !== key) return null;
  return { isAscending: order === constants.table.ASCENDING };
});
</script>

<style scoped lang="scss">
$sort-icon-transition: 0.2s;

:deep(.tooltip-icon) {
  margin-right: 2px;
}

.header {
  white-space: nowrap;
}

.sort-icon {
  transition: $sort-icon-transition;

  &_inverted {
    transform: rotate(-180deg);
  }
}

.hidden-sorting-icon {
  opacity: 0;
  transition: opacity ease-in-out $sort-icon-transition;
  color: currentColor;
}
</style>
